import $ from 'jquery';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = $;

// Install BS5 components as jQuery plugins synchronously here, at module-eval
// time. Bootstrap itself does this on DOMContentLoaded — but jQuery's
// $(document).ready listener was registered first (when jquery was imported)
// and therefore fires first, BEFORE Bootstrap's auto-registration. Any ready
// handler that calls $(x).tooltip() — e.g. summernote-bs5's toolbar init —
// would otherwise hit "tooltip is not a function".
//
// Bootstrap will also run defineJQueryPlugin on DOMContentLoaded and overwrite
// each $.fn.<name> back to the same Ctor.jQueryInterface — harmless redundant
// assignment.
//
// NOTE: Modal.jQueryInterface treats bare $('#x').modal() as "create instance
// only, do NOT show". Call sites that want the modal to open must use
// $('#x').modal('show') explicitly.
['Tooltip', 'Popover', 'Modal', 'Dropdown', 'Collapse', 'Tab', 'Toast',
 'Offcanvas', 'Alert', 'Carousel', 'ScrollSpy']
  .forEach(name => {
    const Ctor = bootstrap[name];
    if (!Ctor || typeof Ctor.jQueryInterface !== 'function') return;
    const key = name.toLowerCase();
    $.fn[key] = Ctor.jQueryInterface;
    $.fn[key].Constructor = Ctor;
  });

export default $;
